export interface DialogConfirmConfig {
    title: string;
    content?: string;
    okText?: string;
    cancelText?: string;
}

export interface DialogEngine {
    confirm(config: DialogConfirmConfig): Promise<void>;
}

class Dialog {

    private static engine: DialogEngine;

    public static setEngine(engine: DialogEngine) {
        this.engine = engine;
    }

    public static async confirm(config: DialogConfirmConfig): Promise<void> {
        await this.engine.confirm(config);
    }
}

export default Dialog;
